import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity, JaarrekeningBalans,
  JaarrekeningVenW
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommandModule } from '@angular/cli/src/command-builder/command-module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tbs-regeling',
  templateUrl: './tbs-regeling.component.html',
  styleUrls: ['./tbs-regeling.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class TbsRegelingComponent implements OnInit {

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;

    public tbsRegeling = {} as FormGroup

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder) {
        this.tbsRegeling = this.fb.group({
            tbsOpbrengsten: this.fb.array<JaarrekeningVenW>([]),
            tbsKosten: this.fb.array<JaarrekeningVenW>([]),
            tbsBezittingen: this.fb.array<JaarrekeningBalans>([]),
            tbsOnroerendeZaken: this.fb.array<JaarrekeningBalans>([]),
            tbsSchulden: this.fb.array<JaarrekeningBalans>([]),
        });
    }

    get tbsOpbrengsten(): FormArray {
        return this.tbsRegeling.get('tbsOpbrengsten') as FormArray;
    }

    get tbsKosten(): FormArray {
        return this.tbsRegeling.get('tbsKosten') as FormArray;
    }

    get tbsBezittingen(): FormArray {
        return this.tbsRegeling.get('tbsBezittingen') as FormArray;
    }

    get tbsOnroerendeZaken(): FormArray {
        return this.tbsRegeling.get('tbsOnroerendeZaken') as FormArray;
    }

    get tbsSchulden(): FormArray {
        return this.tbsRegeling.get('tbsSchulden') as FormArray;
    }

    addRijTbsOpbrengsten(): void {
        this.tbsOpbrengsten.push(this.createJaarrekeningVenWGroup())
    }

    addRijTbsKosten(): void {
        this.tbsKosten.push(this.createJaarrekeningVenWGroup())
    }

    verwijderRijTbsOpbrengsten(index: number): void {
        this.tbsOpbrengsten.removeAt(index)
        this.tbsRegeling.updateValueAndValidity()
        this.tbsRegeling.markAsDirty()
        this.saveForm();
    }

    verwijderRijTbsKosten(index: number): void {
        this.tbsKosten.removeAt(index);
        this.tbsRegeling.updateValueAndValidity()
        this.tbsRegeling.markAsDirty()
        this.saveForm();
    }

    addRijTbsBezittingen(): void {
        this.tbsBezittingen.push(this.createJaarrekeningBalansGroup())
    }

    addRijTbsOnrZaken(): void {
        this.tbsOnroerendeZaken.push(this.createJaarrekeningBalansGroup())
    }

    addRijTbsSchulden(): void {
        this.tbsSchulden.push(this.createJaarrekeningBalansGroup()
        )
    }

    verwijderRijTbsBezittingen(index: number): void {
        this.tbsBezittingen.removeAt(index);
        this.tbsRegeling.updateValueAndValidity()
        this.tbsRegeling.markAsDirty()
        this.saveForm();
    }

    verwijderRijTbsOnrZaken(index: number): void {
        this.tbsOnroerendeZaken.removeAt(index);
        this.tbsRegeling.updateValueAndValidity()
        this.tbsRegeling.markAsDirty()
        this.saveForm();
    }

    verwijderRijTbsSchulden(index: number): void {
        this.tbsSchulden.removeAt(index);
        this.tbsRegeling.updateValueAndValidity()
        this.tbsRegeling.markAsDirty()
        this.saveForm();
    }

    private createJaarrekeningVenWGroup(jaarrekeningVenW?: JaarrekeningVenW): FormGroup {
        return this.fb.group(({
            omschrijving: jaarrekeningVenW ? jaarrekeningVenW.omschrijving : undefined,
            bedrag: jaarrekeningVenW ? jaarrekeningVenW.bedrag : undefined,
            kostensoort: jaarrekeningVenW ? jaarrekeningVenW.kostensoort : undefined,
        } as JaarrekeningVenW))
    }

    private createJaarrekeningBalansGroup(jaarrekeningBalans?: JaarrekeningBalans): FormGroup {
        return this.fb.group(({
            waardeOpening: jaarrekeningBalans ? jaarrekeningBalans.waardeOpening : undefined,
            waardeSlot: jaarrekeningBalans ? jaarrekeningBalans.waardeSlot : undefined,
            omschrijving: jaarrekeningBalans ? jaarrekeningBalans.omschrijving : undefined,
            bodemwaarde: jaarrekeningBalans ? jaarrekeningBalans.bodemwaarde : undefined,
            aanschafWaarde: jaarrekeningBalans ? jaarrekeningBalans.aanschafWaarde : undefined,
            restWaarde: jaarrekeningBalans ? jaarrekeningBalans.restWaarde : undefined,
            nominaleWaarde: jaarrekeningBalans ? jaarrekeningBalans.nominaleWaarde : undefined,
        } as JaarrekeningBalans))
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.tbsRegeling.reset()
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
      if (this.isDefAangifteSubscription) {
          this.isDefAangifteSubscription.unsubscribe();
      }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.tbsRegeling.dirty
  }
    private updateForm(): void {
        // update opbrengsten
        let tbsOpbrengstenLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsOpbrengsten || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                tbsOpbrengstenLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsOpbrengsten || [];
            }
        });
        const formArray = this.tbsRegeling.get('tbsOpbrengsten') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        while (formArray.length > tbsOpbrengstenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }
        for (let i = 0; i < tbsOpbrengstenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(tbsOpbrengstenLijst[i]);
            } else {
                const formGroup = this.createJaarrekeningVenWGroup(tbsOpbrengstenLijst[i]);
                formArray.push(formGroup);
            }
        }
        // update kosten
        let tbsKostenLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsKosten || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                tbsKostenLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsKosten || [];
            }
        });
        const formArrayKosten = this.tbsRegeling.get('tbsKosten') as FormArray;
        while (formArrayKosten.length > tbsKostenLijst.length) {
            formArrayKosten.removeAt(formArrayKosten.length - 1);
        }
        for (let i = 0; i < tbsKostenLijst.length; i++) {
            if (i < formArrayKosten.length) {
                const control = formArrayKosten.at(i) as FormGroup;
                control.patchValue(tbsKostenLijst[i]);
            } else {
                const formGroup = this.createJaarrekeningVenWGroup(tbsKostenLijst[i]);
                formArrayKosten.push(formGroup);
            }
        }
        // update bezittingen
        let tbsBezittingenLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsBezittingen || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                tbsBezittingenLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsBezittingen || [];
            }
        });
        const formArrayBezittingen = this.tbsRegeling.get('tbsBezittingen') as FormArray;
        while (formArrayBezittingen.length > tbsBezittingenLijst.length) {
            formArrayBezittingen.removeAt(formArrayBezittingen.length - 1);
        }
        for (let i = 0; i < tbsBezittingenLijst.length; i++) {
            if (i < formArrayBezittingen.length) {
                const control = formArrayBezittingen.at(i) as FormGroup;
                control.patchValue(tbsBezittingenLijst[i]);
            } else {
                const formGroup = this.createJaarrekeningBalansGroup(tbsBezittingenLijst[i]);
                formArrayBezittingen.push(formGroup);
            }
        }
        // update onroerende zaken
        let tbsOzLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsOnroerendeZaken || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                tbsOzLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsOnroerendeZaken || [];
            }
        });
        const formArrayOz = this.tbsRegeling.get('tbsOnroerendeZaken') as FormArray;
        while (formArrayOz.length > tbsOzLijst.length) {
            formArrayOz.removeAt(formArrayOz.length - 1);
        }
        for (let i = 0; i < tbsOzLijst.length; i++) {
            if (i < formArrayOz.length) {
                const control = formArrayOz.at(i) as FormGroup;
                control.patchValue(tbsOzLijst[i]);
            } else {
                const formGroup = this.createJaarrekeningBalansGroup(tbsOzLijst[i]);
                formArrayOz.push(formGroup);
            }
        }
        // update schulden
        let tbsSchuldenLijst = this.aangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsSchulden || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                tbsSchuldenLijst = this.aangifte?.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden?.tbsSchulden || [];
            }
        });
        const formArraySchulden = this.tbsRegeling.get('tbsSchulden') as FormArray;
        while (formArraySchulden.length > tbsSchuldenLijst.length) {
            formArraySchulden.removeAt(formArraySchulden.length - 1);
        }
        for (let i = 0; i < tbsSchuldenLijst.length; i++) {
            if (i < formArraySchulden.length) {
                const control = formArraySchulden.at(i) as FormGroup;
                control.patchValue(tbsSchuldenLijst[i]);
            } else {
                const formGroup = this.createJaarrekeningBalansGroup(tbsSchuldenLijst[i]);
                formArraySchulden.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    resultaatUitOverigeWerkzaamheden: {
                        ...this.aangifte.box1?.resultaatUitOverigeWerkzaamheden,
                        tbsBezittingen: this.tbsRegeling.value.tbsBezittingen,
                        tbsKosten: this.tbsRegeling.value.tbsKosten,
                        tbsSchulden: this.tbsRegeling.value.tbsSchulden,
                        tbsOpbrengsten: this.tbsRegeling.value.tbsOpbrengsten,
                        tbsOnroerendeZaken: this.tbsRegeling.value.tbsOnroerendeZaken,
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        resultaatUitOverigeWerkzaamheden: {
                            ...this.aangifte.partnerAangifte?.box1?.resultaatUitOverigeWerkzaamheden,
                            tbsBezittingen: this.tbsRegeling.value.tbsBezittingen,
                            tbsKosten: this.tbsRegeling.value.tbsKosten,
                            tbsSchulden: this.tbsRegeling.value.tbsSchulden,
                            tbsOpbrengsten: this.tbsRegeling.value.tbsOpbrengsten,
                            tbsOnroerendeZaken: this.tbsRegeling.value.tbsOnroerendeZaken,
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
        this.tbsRegeling.markAsDirty()
    }
}
